import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../common/CmnContext';
import { SaleListContext } from '../SaleListContext';
import { SaleListSearchInput } from './input/SaleListSearchInput';
import { SaleListSearchLabel } from './label/SaleListSearchLabel';


export function SaleListSearch() {

  const isPc = useContext(cmnContext).isPc;
  const isCheckFullAccess = useContext(SaleListContext).isCheckFullAccess;
  const isFullAccess = useContext(SaleListContext).isFullAccess;
  const isFullaccessPurchased = useContext(SaleListContext).isFullaccessPurchased;

  const searchTypeList = useContext(SaleListContext).searchTypeList;
  const grayColor = useContext(SaleListContext).grayColor;


  return (
    <div style={{
      position: 'sticky',
      top: 0,
      zIndex: 10,
      backgroundColor: grayColor,
      padding: isPc? '2% 4%' : '2% 1%',
    }}>

      {/* 入力検索 */}
      <SaleListSearchInput />

      {/* ラベル検索: フルアクセス意外 */}
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap', //はみ出さないように
        marginTop: 5 
      }}>
        {Object.entries(searchTypeList).map(([key, val]) => (
          <>
            {(
              // 以下は表示する
              isCheckFullAccess &&
              (
                !isFullAccess || //フルアクセスなし
                (isFullAccess && key=='new') || //フルアクセス：新着
                (isFullAccess && key=='benefit') || //フルアクセス：特典付
                (isFullAccess && key=='purchased' && isFullaccessPurchased) || //フルアクセス：所持中(所持中のものがある場合のみ)
                (isFullAccess && key=='favorite') //フルアクセス：お気に入り
              )
            ) &&
              <SaleListSearchLabel
                labelKey={key}
                isCheck={val}
              />
            }
          </>
        ))}
      </div>

    </div>
  );
}